import React from "react";
import TablaBeneficio from "js/components/TablaBeneficio";

function Beneficio(props) {
  return <TablaBeneficio />;
}

export default Beneficio;
